import { FolderCopyOutlined } from "@mui/icons-material";
import { FC, useState } from "react";
import {
  MuiBox,
  MuiButtonTertiary,
  MuiTypography,
} from "../../../../../components";
import PermissionWrapper from "../../../../../components/permissionWrapper/PermissionWrapper";
import {
  MODULE_PERMISSIONS,
  SummaryStatus,
} from "../../../../../helpers/constants";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { CancelFieldModal } from "../../../../createProgramTemplate/components/cancelFieldModal/CancelFieldModal";
import { BulkUploadStatusResponse } from "../../../modelsAndSchema/Models";
import { bulkCreateProgramSiteCoreKeys } from "../../../siteCore/siteCoreKeys";
import { BulkProgramStatusPanel } from "../../bulkProgramStatusPanel/BulkProgramStatusPanel";
import { BulkCreateProgramProcessWrapper } from "./BulkCreateProgramProcess.style";

export interface BulkCreateProgramUploadProps {
  onRefresh: () => void;
  onCreateNewBulkProgram: () => void;
  summaryData: BulkUploadStatusResponse;
  onDownloadUploadedFile: () => void;
  onCancelProcess: () => void;
  isEditBulkProgram: boolean;
}

export const BulkCreateProgramProcess: FC<BulkCreateProgramUploadProps> = ({
  onRefresh,
  onCreateNewBulkProgram,
  summaryData,
  onDownloadUploadedFile,
  onCancelProcess,
  isEditBulkProgram,
}) => {
  const { useFetchLabel } = useSiteCore();
  const getLabel = useFetchLabel(
    bulkCreateProgramSiteCoreKeys.summaryComponent,
  );

  const [showCancel, setShowCancel] = useState<boolean>(false);

  const recordStats = {
    total: {
      count: summaryData?.totalRecords,
      label: getLabel(bulkCreateProgramSiteCoreKeys.totalNumberOfRecords),
    },
    processed: {
      count: summaryData?.processedRecords,
      label: getLabel(bulkCreateProgramSiteCoreKeys.processedRecords),
    },
  };

  const handleCancelProcess = () => {
    setShowCancel(true);
  };

  const closeModalHandler = () => setShowCancel(false);

  const cancelConfirmHandler = () => {
    setShowCancel(false);
    onCancelProcess();
  };

  return (
    <BulkCreateProgramProcessWrapper>
      <BulkProgramStatusPanel
        recordStats={recordStats}
        processName={summaryData?.processName}
        status={summaryData?.status}
        onRefresh={onRefresh}
        onCancel={handleCancelProcess}
        onDownloadUploadedFile={onDownloadUploadedFile}
      />
      <MuiTypography variant="h5Bold" component={"p"} className="label">
        {summaryData?.status === SummaryStatus.QUEUE
          ? getLabel(
              bulkCreateProgramSiteCoreKeys.fileInQueueProcessingWaitMessage,
            )
          : getLabel(
              bulkCreateProgramSiteCoreKeys.bulkCreateProgramInstructionalMessage,
            )}
      </MuiTypography>
      <PermissionWrapper
        permission={
          isEditBulkProgram
            ? MODULE_PERMISSIONS.BULK_EDIT
            : MODULE_PERMISSIONS.BULK_CREATE
        }
      >
        <MuiBox className="footer-button">
          <MuiButtonTertiary
            onClick={onCreateNewBulkProgram}
            data-testid={"add-new-bulk-program"}
          >
            <FolderCopyOutlined />
            {isEditBulkProgram
              ? getLabel(bulkCreateProgramSiteCoreKeys.bulkEditProgramCTAButton)
              : getLabel(
                  bulkCreateProgramSiteCoreKeys.createNewBulkProgramLink,
                )}
          </MuiButtonTertiary>
        </MuiBox>
      </PermissionWrapper>
      {showCancel && (
        <CancelFieldModal
          showModal={showCancel}
          handleModalClose={closeModalHandler}
          handlePrimaryButtonClick={cancelConfirmHandler}
          cancelMessage={getLabel(
            bulkCreateProgramSiteCoreKeys.cancelBulkProcessConfirmationMessage,
          )}
        />
      )}
    </BulkCreateProgramProcessWrapper>
  );
};
